export class AbstractLayout {
    /**
     * Constructs an instance of AbstractLayout with the given container and options.
     * @param {HTMLElement} container - The container element where the layout will be applied.
     * @param {ResolvedOptions} options - The resolved options to apply to the layout.
     */
    constructor(container, options) {
        this.rootSelector = options.root;
        this.lightLabel = options.lightLabel;
        this.darkLabel = options.darkLabel;
        this.style = options.style;
        this.lightAriaLabel = options.lightAriaLabel;
        this.darkAriaLabel = options.darkAriaLabel;
        container.innerHTML = "";
        this.createControl(container);
    }
    /**
     * Gets the root elements in the layout.
     *
     * Implementation note: roots are not cached to avoid re-querying the DOM because roots can change (added or removed) during runtime.
     * @returns {HTMLElement[]} The root elements in the layout.
     */
    get roots() {
        return Array.from(globalThis.document.querySelectorAll(this.rootSelector));
    }
    /**
     * Returns the aria label based on the given dark mode state.
     * @param {boolean} isLight - The dark mode state.
     * @returns {string} The aria label.
     **/
    getAriaLabel(isLight) {
        return isLight ? this.lightAriaLabel : this.darkAriaLabel;
    }
    /**
     * Updated DOM to current state.
     * - Launch the control state update
     * - Sets the color scheme of all root elements in the layout based on the given current state.
     * @param {DarkModeState} state - The darkmode current state.
     */
    setState(state) {
        this.updateControlState(state);
        this.roots.forEach((el) => {
            el.dataset[AbstractLayout.BS_ATTRIBUTE] = state.theme;
        });
    }
}
AbstractLayout.BS_ATTRIBUTE = "bsTheme";
